import { render } from "./TopSearchField.vue?vue&type=template&id=67f57f70&scoped=true"
import script from "./TopSearchField.vue?vue&type=script&lang=js"
export * from "./TopSearchField.vue?vue&type=script&lang=js"

import "./TopSearchField.vue?vue&type=style&index=0&id=67f57f70&scoped=true&lang=css"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f57f70"]])

export default __exports__